export default {
	preparePayloadData: (state) => (key) => state[key].map(value => value.id)
}